import { render, staticRenderFns } from "./TestemunhasCollapse.vue?vue&type=template&id=28ee83cb&scoped=true&"
import script from "./TestemunhasCollapse.vue?vue&type=script&lang=js&"
export * from "./TestemunhasCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee83cb",
  null
  
)

export default component.exports